import NestedForm from "stimulus-rails-nested-form"

export default class extends NestedForm {
  static targets = ["addButton"]

  // Ein neuer Upload-Slot wird eingefügt, der Button wird ausgeblendet bis hochgeladen oder Slot gelöscht wurde.
  add(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    if (this._addInProgress) return
    this._addInProgress = true

    const template = this.templateTarget
    const wrapperSelector = this.wrapperSelectorValue
    const timestamp = new Date().getTime().toString()
    let content = null

    if (template.content && template.content.cloneNode) {
      const fragment = template.content.cloneNode(true)
      const first = fragment.querySelector && fragment.querySelector(wrapperSelector)
      if (first) content = first.outerHTML.replace(/NEW_RECORD/g, timestamp)
    }
    if (!content && template.querySelector) {
      const first = template.querySelector(wrapperSelector)
      if (first) content = first.outerHTML.replace(/NEW_RECORD/g, timestamp)
    }
    if (content) {
      this.targetTarget.insertAdjacentHTML("beforebegin", content)
      if (this.hasAddButtonTarget) {
        this.addButtonTarget.style.display = "none"
      }
    }

    setTimeout(() => { this._addInProgress = false }, 300)
  }

  remove(event) {
    super.remove(event)
    if (this.hasAddButtonTarget) {
      const wrapperSelector = this.wrapperSelectorValue
      const hasNewRecord = this.element.querySelector(`${wrapperSelector}[data-new-record="true"]`)
      if (!hasNewRecord) {
        this.addButtonTarget.style.display = ""
      }
    }
  }
}
